// CRA inlines REACT_APP_* at build time; if client/.env is missing they become "undefined".
// Fallbacks keep Shopify admin URLs valid even when the build env is incomplete.
export const APP_PATH = process.env.REACT_APP_PATH || "advancedshippingrates"
export const APP_NAME = process.env.REACT_APP_NAME || "Advanced Shipping Rates"
